import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useAssignReservationMutation } from "../../../store/api/school/ReservationSlice";
import { useGetAllActiveDriversQuery } from "../../../store/api/school/VendorSlice";

const initialState = {
  driver_id: "",
};

const BusCharterAssignDriver = ({ bookingId }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [drivers, setDrivers] = useState([]);

  // Get active drivers
  const { data, isSuccess } = useGetAllActiveDriversQuery();

  // Assign mutation
  const [assignReservation, { isLoading }] = useAssignReservationMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({
      ...prev,
      [name]: value ? "" : `${t("errors." + name)} ${t("errors.required")}`,
    }));
  };

  useEffect(() => {
    if (isSuccess && data?.data) {
      setDrivers(data.data.drivers);
    }
  }, [data, isSuccess]);

  const validateForm = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value)
        newErrors[key] = `${t("errors." + key)} ${t("errors.required")}`;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    toast.dismiss();
    try {
      let response = await assignReservation({
        data: formData,
        id: bookingId,
        endPoint: "assign",
      }).unwrap();
      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success(response.message);
        setShow(false);
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  return (
    <>
      <Button onClick={() => setShow(true)}>{t("btns.assign")}</Button>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="md"
        centered
        backdrop="static"
        // className="assignModel"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="h5">
            {t("assign-resources-to-booking")} #{bookingId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "calc(90vh - 120px)",
            overflowY: "auto",
          }}
        >
          <div>
            <ul className="form d-flex flex-wrap p-0 pt-2">
              {/* Driver */}
              <li className="col-12">
                <label className="filedHd">{t("driver")}</label>
                <select
                  className="formSelect"
                  name="driver_id"
                  value={formData.driver_id}
                  onChange={handleChange}
                >
                  <option value="">
                    {t("select")} {t("driver")}
                  </option>
                  {drivers?.map((item, i) => (
                    <option value={item?.driver_details?.driver_id} key={i}>
                      {item?.full_name}
                    </option>
                  ))}
                </select>
                {errors?.driver_id && (
                  <span style={{ color: "red" }}>{errors.driver_id}</span>
                )}
              </li>
            </ul>
            <div className="text-center mt-5">
              <Button
                disabled={isLoading}
                className="smallBtn cancel me-3"
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.assign")
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BusCharterAssignDriver;
